import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { FormikProvider, useFormik } from 'formik'
import { Button, DialogActions, DialogContent, DialogTitle, Divider, Modal, ModalDialog, Stack } from '@mui/joy'
import { sendMessageToProjectUsersSchema } from 'validations/sms/sendMessageToProjectUsersSchema'
import CustomEditorControl from 'components/forms/CustomEditorControl'
import CustomSelectControl from 'components/forms/CustomSelectControl'
import { SEND_MESSAGE_TYPES, SEND_MESSAGE_TYPES_ARRAY } from 'utils/config'
import CustomRadioControl from './forms/CustomRadioControl'
import CustomInputControl from './forms/CustomInputControl'

const MessageProjectModal = ({ open, setObject, handleSubmit, title = 'Wyślij wiadomość', children, loading }) => {
  const { currentProject } = useSelector((s) => s.projects)

  const formik = useFormik({
    initialValues: { message: '', group: null, subject: '', type: SEND_MESSAGE_TYPES.sms.value },
    validationSchema: sendMessageToProjectUsersSchema,
    onSubmit: handleSubmit,
  })

  useEffect(() => {
    formik.resetForm()
  }, [open])

  return (
    <Modal open={Boolean(open)} onClose={() => setObject(false)}>
      <ModalDialog variant="outlined" role="alertdialog" sx={{ maxWidth: '500px', width: '100%' }}>
        <DialogTitle>{title}</DialogTitle>
        <Divider />
        <DialogContent>{children}</DialogContent>
        <FormikProvider value={formik}>
          <form onSubmit={formik.handleSubmit}>
            <Stack spacing={2}>
              <CustomSelectControl
                label="Grupa docelowa"
                name="group"
                options={[
                  { value: 'assignment', label: 'Zapisani', type: [1, 2, 3] },
                  { value: 'reserveList', label: 'Lista rezerwowa', type: [1, 2, 3] },
                  { value: 'assignment_reserveList', label: 'Zapisani + lista rezerwowa', type: [1, 2, 3] },
                  { value: 'approved', label: 'Wszyscy zapisani do projektu', type: [2, 3] },
                ].filter((o) => o.type.includes(currentProject.type))}
                formik={formik}
              />
              <CustomRadioControl
                name="type"
                label="Rodzaj wiadomości"
                options={SEND_MESSAGE_TYPES_ARRAY}
                formik={formik}
                orientation="horizontal"
              />
              {formik.values.type === SEND_MESSAGE_TYPES.email.value && (
                <CustomInputControl name="subject" label="Tytuł email" formik={formik} />
              )}
              <CustomEditorControl name="message" label="Treść wiadomości" formik={formik} />
            </Stack>
          </form>
        </FormikProvider>
        <DialogActions>
          <Button
            variant="solid"
            color="primary"
            onClick={formik.handleSubmit}
            loading={loading}
            disabled={!formik.isValid || loading}
          >
            Wyślij wiadomość
          </Button>
          <Button variant="plain" color="neutral" onClick={() => setObject(false)} disabled={loading} loading={loading}>
            Anuluj
          </Button>
        </DialogActions>
      </ModalDialog>
    </Modal>
  )
}

MessageProjectModal.propTypes = {
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.object, PropTypes.array]).isRequired,
  setObject: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  children: PropTypes.node,
  title: PropTypes.string,
  loading: PropTypes.bool,
}

export default MessageProjectModal
